module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0020.jpg?v=522a3d30";